// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/source/api/source_sync.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_source_resources_file_upload_intent_file_upload_intent } from "../resources/file_upload_intent/file_upload_intent_pb.js";
import { file_services_source_resources_source } from "../resources/source_pb.js";
import { file_services_source_resources_source_sync } from "../resources/source_sync_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";
import { file_shared_sorting } from "../../../shared/sorting_pb.js";

/**
 * Describes the file services/source/api/source_sync.proto.
 */
export const file_services_source_api_source_sync = /*@__PURE__*/
  fileDesc("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", [file_services_database_models_public, file_services_source_resources_file_upload_intent_file_upload_intent, file_services_source_resources_source, file_services_source_resources_source_sync, file_shared_pagination, file_shared_sorting]);

/**
 * Describes the message gx.source.api.CreateSourceSyncRequest.
 * Use `create(CreateSourceSyncRequestSchema)` to create a new message.
 */
export const CreateSourceSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 0);

/**
 * Describes the message gx.source.api.FileUploadSyncInit.
 * Use `create(FileUploadSyncInitSchema)` to create a new message.
 */
export const FileUploadSyncInitSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 1);

/**
 * Describes the message gx.source.api.WebhookSyncInit.
 * Use `create(WebhookSyncInitSchema)` to create a new message.
 */
export const WebhookSyncInitSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 2);

/**
 * Describes the message gx.source.api.TextSyncInit.
 * Use `create(TextSyncInitSchema)` to create a new message.
 */
export const TextSyncInitSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 3);

/**
 * Describes the message gx.source.api.CreateSourceSyncResponse.
 * Use `create(CreateSourceSyncResponseSchema)` to create a new message.
 */
export const CreateSourceSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 4);

/**
 * Describes the message gx.source.api.GetSourceSyncRequest.
 * Use `create(GetSourceSyncRequestSchema)` to create a new message.
 */
export const GetSourceSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 5);

/**
 * Describes the message gx.source.api.GetSourceSyncResponse.
 * Use `create(GetSourceSyncResponseSchema)` to create a new message.
 */
export const GetSourceSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 6);

/**
 * Describes the message gx.source.api.ListSourceSyncsRequest.
 * Use `create(ListSourceSyncsRequestSchema)` to create a new message.
 */
export const ListSourceSyncsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 7);

/**
 * Describes the message gx.source.api.ListSourceSyncsResponse.
 * Use `create(ListSourceSyncsResponseSchema)` to create a new message.
 */
export const ListSourceSyncsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 8);

/**
 * Describes the message gx.source.api.UpdateSourceSyncRequest.
 * Use `create(UpdateSourceSyncRequestSchema)` to create a new message.
 */
export const UpdateSourceSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 9);

/**
 * Describes the message gx.source.api.UpdateSourceSyncResponse.
 * Use `create(UpdateSourceSyncResponseSchema)` to create a new message.
 */
export const UpdateSourceSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 10);

/**
 * Describes the message gx.source.api.DeleteSourceSyncRequest.
 * Use `create(DeleteSourceSyncRequestSchema)` to create a new message.
 */
export const DeleteSourceSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 11);

/**
 * Describes the message gx.source.api.DeleteSourceSyncResponse.
 * Use `create(DeleteSourceSyncResponseSchema)` to create a new message.
 */
export const DeleteSourceSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 12);

/**
 * Describes the message gx.source.api.GetLatestSourceSyncRequest.
 * Use `create(GetLatestSourceSyncRequestSchema)` to create a new message.
 */
export const GetLatestSourceSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 13);

/**
 * Describes the message gx.source.api.GetLatestSourceSyncResponse.
 * Use `create(GetLatestSourceSyncResponseSchema)` to create a new message.
 */
export const GetLatestSourceSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 14);

/**
 * Describes the message gx.source.api.CancelSourceSyncRequest.
 * Use `create(CancelSourceSyncRequestSchema)` to create a new message.
 */
export const CancelSourceSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 15);

/**
 * Describes the message gx.source.api.CancelSourceSyncResponse.
 * Use `create(CancelSourceSyncResponseSchema)` to create a new message.
 */
export const CancelSourceSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_source_api_source_sync, 16);

/**
 * @generated from service gx.source.api.SourceSyncService
 */
export const SourceSyncService = /*@__PURE__*/
  serviceDesc(file_services_source_api_source_sync, 0);

